export const fadeIn = {
    '@keyframes fadeIn': {
        from: {
            display: 'flex',
            opacity: '0',
        },
        to: {
            opacity: '1.0',
        },
    },
};
export const fadeOut = {
    '@keyframes fadeOut': {
        from: {
            opacity: '1.0',
        },
        to: {
            display: 'block',
            opacity: '0',
        },
    },
};
export const animationUsage = (animation = '$fadeIn', duration, animationDirection = 'normal') => ({
    animationName: animation,
    animationDuration: duration,
    animationTimingFunction: 'linear',
    animationDirection,
});
//# sourceMappingURL=Animations.js.map